module.exports = __webpack_public_path__ + "waist.d1845e04.png";


//////////////////
// WEBPACK FOOTER
// /var/www/build-lk-1/src/components/profile/imgs/waist.png
// module id = 1925
// module chunks = 0